// 先导入所有图片
import img1_1_1 from "../../../assets/images/yzqf/glp/1-1-1.jpg";
import img1_1_2 from "../../../assets/images/yzqf/glp/1-1-2.jpg";
import img1_2_1 from "../../../assets/images/yzqf/glp/1-2-1.jpg";
import img1_2_2 from "../../../assets/images/yzqf/glp/1-2-2.jpg";
import img2_1_1 from "../../../assets/images/yzqf/glp/2-1-1.jpg";
import img2_1_2 from "../../../assets/images/yzqf/glp/2-1-2.jpg";
import img2_2_1 from "../../../assets/images/yzqf/glp/2-2-1.jpg";
import img2_3_1 from "../../../assets/images/yzqf/glp/2-3-1.jpg";
import img2_4_1 from "../../../assets/images/yzqf/glp/2-4-1.jpg";
import img2_5_1 from "../../../assets/images/yzqf/glp/2-5-1.jpg";
import img2_5_2 from "../../../assets/images/yzqf/glp/2-5-2.jpg";
import img2_6_1 from "../../../assets/images/yzqf/glp/2-6-1.jpg";
import img3_1_1 from "../../../assets/images/yzqf/glp/3-1-1.jpg";
import img3_1_2 from "../../../assets/images/yzqf/glp/3-1-2.jpg";
import img3_1_3 from "../../../assets/images/yzqf/glp/3-1-3.jpg";
import img3_3_1 from "../../../assets/images/yzqf/glp/3-3-1.jpg";
import img3_3_2 from "../../../assets/images/yzqf/glp/3-3-2.jpg";

import img3_4_1 from "../../../assets/images/yzqf/glp/3-4-1.jpg";
import img3_4_2 from "../../../assets/images/yzqf/glp/3-4-2.jpg";
import img3_4_3 from "../../../assets/images/yzqf/glp/3-4-3.jpg";
import img3_4_4 from "../../../assets/images/yzqf/glp/3-4-4.jpg";
import img4_1_1 from "../../../assets/images/yzqf/glp/4-1-1.jpg";
import img4_1_2 from "../../../assets/images/yzqf/glp/4-1-2.jpg";
import img4_1_3 from "../../../assets/images/yzqf/glp/4-1-3.jpg";

export const glpdata = {
  jygq: [
    {
      images: [
        {
          img: img1_1_1,
          imgtitle: "高罗佩为其师叶诗梦所绘小像",
        },
        {
          img: img1_1_2,
          imgtitle: "高罗佩与琴人关仲航对弹间隙",
        },
      ],
      cont: "<p>高罗佩最初如何认识到中国古琴似乎已难以说清，可能是在他中学至大学期间学习中文的时候。1935年，博士刚毕业的高罗佩到荷兰驻日本公使馆任翻译工作。次年9月，他利用出差的机会到北京开展了为期一个月的访问学习，拜琴坛耆宿叶诗梦为师，还买了一张老琴，第一次真正接触中国古琴。返回日本后，高罗佩继续学琴，每天弹奏，数年不断，而且只要一有机会，他便前往中国，1941年初曾到北京跟随九嶷派琴家关仲航习琴。</p>",
    },
    {
      images: [
        {
          img: img1_2_1,
          imgtitle: "高罗佩自刻印章“中和琴室”",
        },
        {
          img: img1_2_2,
          imgtitle: "1936年高罗佩在日本的书房抚琴",
        },
      ],
      cont: "<p>他在住所中单辟一间屋子用于存放关于中国音乐的书籍和文稿，并将之命名为「中和琴室」，甚至自学了修理古琴。</p>",
    },
  ],
  cqqy: [
    {
      images: [
        {
          img: img2_1_1,
          imgtitle: "高罗佩与水世芳",
        },
        {
          img: img2_1_2,
          imgtitle: "高罗佩与水世芳穿中国古装的合影",
        },
      ],
      cont: "<p>1943年3月，高罗佩被派到中国战时首都重庆工作，在荷兰驻华公使馆任一等秘书，负责大使馆联络办公室的工作，并与名媛水世芳相恋、结婚、生子。</p>",
    },
    {
      images: [
        {
          img: img2_2_1,
          imgtitle:
            "1940年代中期，在重庆的一次雅集中，高罗佩抚琴，杨大钧弹琵琶。前坐者为马衡，高罗佩身后戴眼镜着西装者为傅振伦",
        },
      ],
      cont: "<p>在重庆的岁月里，高罗佩“堪称比中国人还要更中国人”。</p><p>他在自传稿中对在重庆的三年做了这样的评价：“在重庆度过的岁月，对我在学术和艺术方面的研究，具有了不可估量的价值：来自中国所有重大文化中心的最优秀学者和艺术家都聚集在这里……我加入了几个文学协会，其中最重要的是‘天风琴社’，在那儿我遇到了很多于右任那样的知名学者和像‘信仰基督教的’冯玉祥将军那样的很有趣的人物。我们与四川本地的‘富裕阶层’保持了密切联系，在没有日本飞机袭击时，我们在那些富人的郊外别墅里度过美好的周末。我现在首次完全进入了中国人的生活方式……”</p><p>从大学期间研究陶渊明开始，高罗佩将“真正进入中国文人的生活方式”作为毕生的追求。他加入“天风琴社”不仅仅因为爱好古琴音乐，更大的目的在于进入中国传统的文人圈子，而古琴就是他敲开这扇文化之门的试金石。他习惯于把古琴带到重庆的各种社交场所，在晚饭后、在参观中，只要是他认为“符合演奏氛围”的地方，他都乐意现场给友人们弹奏几曲。</p>",
    },
    {
      images: [
        {
          img: img2_3_1,
          imgtitle: "吟月盦前的高罗佩",
        },
      ],
      cont: "<p>据时任国立复旦大学教授的方豪先生回忆，他们受“中国词典馆”杨家骆先生之邀参观北温泉时，还曾在一山洞中听高罗佩鼓琴。1943年9月14日，高罗佩参加了政要王芃生家中举行的中秋雅集。后来王芃生在为《明末义僧东皋禅师集刊》所写的序言中提到，他曾两次听高罗佩弹《高山流水》，一次是高罗佩在日本初学古琴之时，一次即是这次雅集，其间相隔七年：</p><p>“时正研析米南宫砚谱，且试习七弦琴，休沐过从，偶为余操《高山》《流水》之曲，似尚未尽娴……倾者中秋佳夕，月明人静，承偕其未婚妻水世芳女士与美国东方学者艾维廉博士翩临茅舍。嘉陵江畔，瓜果清供，君鼓宋琴，艾吹铁笛，引吭而歌，赓相酬唱，管弦既协，逸兴遄飞，七载以来，无此清福。因忆当年《高山》《流水》之音，益信业精于勤。”</p><p>七年的勤学苦练加上西方音乐理论的基础，高罗佩在重庆时期的琴艺算得上已臻佳境。因此他也积极地参加一些公开演出活动，“多次在战时首都爆满的大厅里进行了古琴演奏活动，为慈善目标募捐”。昆曲演唱家张充和也曾回忆说，在抗战时期的重庆，查阜西和高罗佩常常一同切磋琴艺，而她就在一旁听琴、学琴，并曾与二人一同登台献艺。广陵派琴家张子谦在《操缦琐记》中曾评价高罗佩说：</p><p>“高君（高罗佩）奏《长门》颇有功夫，惜板拍徽位稍差。据云能操八九曲。异邦人有此程度，尤其对于琴学一切，几于无所不知，洵足惊异。”</p>",
    },
    {
      images: [
        {
          img: img2_4_1,
          imgtitle: "高罗佩（左一）参加重庆琴家杨少五家中古琴雅集",
        },
      ],
      cont: "<p>中国学者陈之迈在他写的高罗佩小传（书名为《荷兰高罗佩》）里，就高罗佩弹奏古琴的水平说道：“我刚认识高罗佩时，他已经是弹奏中国古琴的大师了。古琴是相当笨重的乐器，但高罗佩习惯于把它带到重庆的各种社交场所，喜欢在饭后给朋友们弹奏几支曲子。我还记得很清楚，有一次，在一个炎热的夏夜，我们大家在位于嘉陵江岸边一个险要山坡上的房子里吃晚餐。吃完饭之后，高罗佩博士就开始弹奏一支古老的曲子，那是一首名为《高山流水》的曲子。那次聚会充满着浪漫的气氛，我们大家都极其享受这种浪漫，高罗佩博士也非常喜欢这种中国传统含义上的浪漫。就身体特征而言，这位来自欧洲的年轻人，与我们中国人存在很大的差异，所以当他给我们演奏在中国人灵魂中生存了两千多年的曲子时，我们完全被他吸引住了。在后来的几年中，高罗佩博士多次在战时首都爆满的大厅里进行了古琴演奏活动，为慈善目标募捐。那就是他对中国抗日战争的贡献。这样，他的音乐成为了他的外交活动的一个部分。”</p>",
    },
    {
      images: [
        {
          img: img2_5_1,
          imgtitle: "",
        },
        {
          img: img2_5_2,
          imgtitle: "",
        },
      ],
      cont: "<p>高罗佩通晓中国文化，善于从中国文化的内部观察和体验中国，很快在他向往的中国社会中建立了各种联系，于右任、郭沫若、徐悲鸿、齐白石、沈尹默等人都是他的朋友，甚至与四川“哥老会”之类的秘密团体也有交情交道。</p>",
    },
    {
      images: [
        {
          img: img2_6_1,
          imgtitle: "",
        },
      ],
      cont: "<p>他广泛的交游，不仅满足了他的个人兴趣，对其外交工作亦具有不可估量的价值，往往在与中国高官学者一同逛书店、古董店或者欣赏书画、弹奏古琴时，就轻松获得了各种情报。</p>",
    },
  ],
  xsyj: [
    {
      images: [
        {
          img: img3_1_1,
          imgtitle:
            "《明末义僧东皋禅师集刊》线装本函套，商务印书馆，一九四四年",
        },
        {
          img: img3_1_2,
          imgtitle: "高罗佩将《明末义僧东皋禅师集刊》赠送给袛园寺时所附献题",
        },
        {
          img: img3_1_3,
          imgtitle: "高罗佩为琴友徐元白录王维诗",
        },
      ],
      cont: "<p>高罗佩的琴学研究根植于他丰富的文献收藏，20世纪40年代，他在北京、重庆、昆明等地广泛收集中国古旧图书。据学者统计，高罗佩生前藏书约3400种以上，约1万册，大多数于1977年被荷兰莱顿大学汉学院图书馆所收购，其中包括72册中国和日本的音乐书籍。这些书籍中，有明清及民国时期的琴书（谱）20余种，散见琴谱10余篇。</p><p>高罗佩对古琴的研究成果主要产生于他在日本的那段时期：1937年发表文章《无名琴记》与《琴铭研究》；1938年分期发表了英文书稿《琴道》，以及后来被作为专著附录的文章《中国雅乐及其在日本的传播》《三张古董琴》；1941年出版专著《嵇康及其琴赋》；1942年完成了《明末义僧东皋禅师集刊》的第一稿。</p><p>1944年，高罗佩的中文书稿《明末义僧东皋禅师集刊》在重庆商务印书馆出版。高罗佩在书中收录了他在日本搜集的琴僧东皋心越禅师的诗文，并对其生平经历和传艺谱系进行了详细的考证说明。东皋是明朝末年东渡日本的反清义士，高罗佩认为正是他将中国的古琴艺术带到了日本并传承数代。而书中收录的大量东皋爱国诗文在当时具有极强的时代特征与现实意义。</p>",
    },
    {
      images: [
        {
          img: img3_3_1,
          imgtitle: "“东方福尔摩斯之父”高罗佩",
        },
        {
          img: img3_3_2,
          imgtitle: "“东方福尔摩斯之父”高罗佩",
        },
      ],
      cont: "<p>高罗佩是将中国唐代名臣狄仁杰的故事翻译成英文的第一人，并在此基础上，他以自己深厚的汉学底蕴和历史修养，于1949年到1967年这15年间，陆续创作了17部使之饮誉世界的狄公小说。</p>",
    },
    {
      images: [
        {
          img: img3_4_1,
          imgtitle: "高罗佩为狄公案小说手绘地图",
        },
        {
          img: img3_4_2,
          imgtitle: "高罗佩手绘《四漆屏》插图",
        },
        {
          img: img3_4_3,
          imgtitle: "《大唐狄公案》中文译本第一卷封面",
        },
        {
          img: img3_4_4,
          imgtitle: "各种语言版本的《大唐狄公案》封面",
        },
      ],
      cont: "<p>《大唐狄公案》系列探案小说面世后，被译为多种语言在多个国家出版发行，在欧美文坛引起轰动，并深受西方读者的广泛欢迎，在相当长的时间里成为西方人了解中国传统文化的最佳入口。</p>",
    },
  ],
  grsc: [
    {
      images: [
        {
          img: img4_1_1,
          imgtitle: "明代“松风”琴",
        },
        {
          img: img4_1_2,
          imgtitle: "清代“无射”琴",
        },
        {
          img: img4_1_3,
          imgtitle: "清代无名琴",
        },
      ],
      cont: "<p>高罗佩收藏的第一张古琴应该是1936年在北京向叶诗梦求学期间所购得的，他在《琴道》一书的中文后序中曾写道：“丙子秋莫，于宛平得一琴，殆明清间物。无铭，抚之铿锵有余韵。弗敢冒高士选雅名，铭之曰‘无名’。”他在日本练琴所用应该就是这一张琴。</p><p>《琴道》的注释中另外还提到一张明代潞王“中和”琴，是他1938年购于上海，其“中和琴室”之名也由此而来。</p><p>2013年，高罗佩后人将其收藏的部分中国文物捐赠给重庆中国三峡博物馆，其中有三张仲尼式古琴：一张明代“松风”琴，一张清代“无射”琴，还有一张清代无名琴。</p><hr/><p>重庆中国三峡博物馆原本也有一张名为“松风”的古琴，清代，连珠式，系杨少五旧藏。这两张“松风”琴底部的铭文完全一样：琴项有阴刻篆书“松风”二字；龙池下一枚边长4.5厘米方形阴刻填红篆书印文“中和琴室”，应该出自一人之手。推测这两张琴曾同时为高罗佩所有，其中一张赠（售）予了杨少五。</p><p>因此，高罗佩一生收藏过的古琴至少有六张。他将收藏的古琴视若至宝，跟所有中国琴家一样将它们悬挂在书房墙上作为装饰。高罗佩认为，七弦古琴不仅是一件珍贵的乐器，而且在很大程度上也是一件古老的艺术品，它构成一个文人书房里的实质性元素。</p>",
    },
  ],
};
